/* eslint-disable no-nested-ternary */
import React from 'react';
import { FormApi } from 'final-form';
import Input, { AmountInput, Select, SelectItem } from 'ui/Input';
import { onlyNCharacters } from 'utils/formatters';
import { ISSNITPaymentsState, IFormValues, Steps } from './SSNIT.model';

const renderAdviceNumber = () => (
  <>
    <Input name="adviceNumber" label="Payment Advice Number" />
  </>
);

const renderCustomerName = () => (
  <>
    <Input name="customerName" label="Customer Name" />
  </>
);

const renderCustomerCode = () => (
  <>
    <Input name="customerCode" label="Customer Code" />
  </>
);

const renderContributionType = (step) => (
  <>
    <Select name="contributionType" label="Contribution Type" disabled={step !== Steps.VERIFY}>
      <SelectItem value="regular" key="regular">
        Regular
      </SelectItem>
      <SelectItem value="arrears" key="arrears">
        Arrears
      </SelectItem>
    </Select>
  </>
);

// FIRST PROCEED
const renderContributionAmount = (currency: string) => (
  <AmountInput currency={currency} name="contributionAmount" label="Total Contribution Amount" disabled />
);

const renderPenaltyAmount = (currency: string) => (
  <AmountInput currency={currency} name="penaltyAmount" label="Total Penalty Amount" disabled />
);

const renderPayAmount = (currency: string) => (
  <AmountInput currency={currency} name="payAmount" label="Total Amount to Pay" disabled />
);

const renderEstablishmentName = () => (
  <>
    <Input name="establishmentName" label="Establishment Name" disabled />
  </>
);

const renderReceiptId = () => (
  <>
    <Input name="receiptId" label="Receipt ID" disabled />
  </>
);

const renderAdviceReference = () => (
  <>
    <Input name="adviceReference" label="Payment Advice Reference" disabled />
  </>
);

const renderAdviceDate = () => (
  <>
    <Input name="adviceDate" label="Payment Advice Date" disabled />
  </>
);

// SECOND PROCEED
export const renderSourceAccountFieldSelect = (accounts: ISSNITPaymentsState['accounts'], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderSourceAccountFieldInput = () => (
  <>
    <Input name="sourceAccount" label="Source Account" disabled />
  </>
);

export const renderNarrationField = () => (
  <>
    <Input
      name="narration"
      label="Narration"
      fieldProps={{
        parse: onlyNCharacters(25),
      }}
    />
  </>
);

const renderSSNITFields = (
  values: IFormValues,
  form: FormApi<IFormValues>,
  state: ISSNITPaymentsState,
  submitting: boolean,
  step: Steps,
) => {
  if (state.accounts.length === 1) {
    form.mutators.changeFieldValue('sourceAccount', state.accounts[0].accountNumber);
  }
  const fields = (
    <>
      {step === Steps.SECOND_PROCEED
        ? state.accounts.length > 1
          ? renderSourceAccountFieldSelect(state.accounts, submitting)
          : renderSourceAccountFieldInput()
        : null}

      {step === Steps.SECOND_PROCEED ? renderNarrationField() : null}
      {renderAdviceNumber()}
      {renderCustomerName()}
      {renderCustomerCode()}
      {renderContributionType(step)}
      {step === Steps.FIRST_PROCEED || step === Steps.SECOND_PROCEED ? (
        <>
          {renderContributionAmount(state.currency)}
          {renderPenaltyAmount(state.currency)}
          {renderPayAmount(state.currency)}
          {renderEstablishmentName()}
          {renderReceiptId()}
          {renderAdviceReference()}
          {renderAdviceDate()}
        </>
      ) : null}
    </>
  );
  return fields;
};

export default renderSSNITFields;
